
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-videos",
      function () {
        return require("private-next-pages/help-videos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-videos"])
      });
    }
  